// extracted by mini-css-extract-plugin
module.exports = {"valueDefault":"_923361a","valueGreen":"_687e0e5","valueRed":"_04593c6"};